import { DURATION_SECONDS } from '../../constants';

const mapBurstToNumber = (burst: DURATION_SECONDS): number => {
  switch (burst) {
    case DURATION_SECONDS.FIVE:
      return 5;
    case DURATION_SECONDS.TEN:
      return 10;
    case DURATION_SECONDS.FIFTEEN:
      return 15;
    case DURATION_SECONDS.THIRTY:
      return 30;
    case DURATION_SECONDS.FORTY_FIVE:
      return 45;
    case DURATION_SECONDS.SIXTY:
      return 60;
    case DURATION_SECONDS.NINETY:
      return 90;
    default:
      return -1;
  }
};

export default mapBurstToNumber;
